module.exports = __webpack_public_path__ + "assets/img/office-building-budapart-320.28fe150d.webp";